import { MeetingHrFeedbackResult, HrSupportFeedbackTabFilter } from '../../../../types'

export const hrSupportFeedbackTabInitialFilter: HrSupportFeedbackTabFilter = {
  meetingStatuses: [],
  feedbackResolutions: [MeetingHrFeedbackResult.NoResult],
  companyFromDate: undefined,
  companyToDate: undefined,
  employeeFromDate: undefined,
  employeeToDate: undefined,
}

export const areFeedbackTabFiltersEquals = (obj1: HrSupportFeedbackTabFilter, obj2: HrSupportFeedbackTabFilter): boolean => {
  if (obj1.companyFromDate !== obj2.companyFromDate) return false
  if (obj1.companyToDate !== obj2.companyToDate) return false
  if (obj1.employeeFromDate !== obj2.employeeFromDate) return false
  if (obj1.employeeToDate !== obj2.employeeToDate) return false
  if (obj1.meetingStatuses.toString() !== obj2.meetingStatuses.toString()) return false
  if (obj1.feedbackResolutions.sort().toString() !== obj2.feedbackResolutions.sort().toString()) return false
  return true
}
